import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/img/icons/menu/upgrade-icon.svg';
const _hoisted_1 = {
  class: "navbar-nav"
};
const _hoisted_2 = {
  class: "text-start my-2 px-3"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "upgrade",
  width: "24",
  class: "me-2"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Upgrade Plan", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_sidebar_item = _resolveComponent("sidebar-item");
  const _component_b_link = _resolveComponent("b-link");
  return _openBlock(), _createElementBlock("ul", _hoisted_1, [_createVNode(_component_sidebar_item, {
    link: {
      name: 'Dashboard',
      icon: 'dashboard',
      path: '/dashboard'
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.closeAll())
  }), $data.permission < 5 ? (_openBlock(), _createBlock(_component_sidebar_item, {
    key: 0,
    link: {
      name: 'Campaigns',
      icon: 'campaign'
    },
    modelValue: $data.showCreate,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.showCreate = $event),
    onClick: _cache[4] || (_cache[4] = $event => $options.closeAll('showCreate'))
  }, {
    default: _withCtx(() => [_createVNode(_component_sidebar_item, {
      link: {
        name: 'Regular',
        path: '/campaigns'
      },
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('selected'))
    }), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Autoresponders',
        path: '/autoresponder'
      },
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$emit('selected'))
    })]),
    _: 1
  }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_sidebar_item, {
    link: {
      name: 'Automations',
      icon: 'automation',
      path: '/advanced-automation'
    },
    onClick: _cache[5] || (_cache[5] = $event => $options.closeAll())
  }), $data.permission < 4 ? (_openBlock(), _createBlock(_component_sidebar_item, {
    key: 1,
    link: {
      name: 'Audience',
      icon: 'audience'
    },
    modelValue: $data.showRecipients,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.showRecipients = $event),
    onClick: _cache[12] || (_cache[12] = $event => $options.closeAll('showRecipients'))
  }, {
    default: _withCtx(() => [$data.allowAudience ? (_openBlock(), _createBlock(_component_sidebar_item, {
      key: 0,
      link: {
        name: 'All contacts',
        path: '/audience/list'
      },
      onClick: _cache[6] || (_cache[6] = $event => _ctx.$emit('selected'))
    })) : _createCommentVNode("", true), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Lists',
        path: '/recipients'
      },
      onClick: _cache[7] || (_cache[7] = $event => _ctx.$emit('selected'))
    }), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Segments',
        path: '/segment' + ($data.allowAudience ? 's' : '')
      },
      onClick: _cache[8] || (_cache[8] = $event => _ctx.$emit('selected'))
    }, null, 8, ["link"]), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Webforms',
        path: '/webform'
      },
      onClick: _cache[9] || (_cache[9] = $event => _ctx.$emit('selected'))
    }), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Summary',
        path: '/contact-summary'
      },
      onClick: _cache[10] || (_cache[10] = $event => _ctx.$emit('selected'))
    })]),
    _: 1
  }, 8, ["modelValue"])) : _createCommentVNode("", true), _createVNode(_component_sidebar_item, {
    link: {
      name: 'Reports',
      icon: 'reports'
    },
    modelValue: $data.showReport,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $data.showReport = $event),
    onClick: _cache[17] || (_cache[17] = $event => $options.closeAll('showReport'))
  }, {
    default: _withCtx(() => [_createVNode(_component_sidebar_item, {
      link: {
        name: 'Regular campaigns',
        path: '/campaign-report'
      },
      onClick: _cache[13] || (_cache[13] = $event => _ctx.$emit('selected'))
    }), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Automations',
        path: '/automation-report'
      },
      onClick: _cache[14] || (_cache[14] = $event => _ctx.$emit('selected'))
    }), _createVNode(_component_sidebar_item, {
      link: {
        name: 'Autoresponders',
        path: '/autoresponder-report'
      },
      onClick: _cache[15] || (_cache[15] = $event => _ctx.$emit('selected'))
    })]),
    _: 1
  }, 8, ["modelValue"]), this.user && this.user.mcTemplate && $data.permission < 5 ? (_openBlock(), _createBlock(_component_sidebar_item, {
    key: 2,
    link: {
      name: 'Template gallery',
      icon: 'gallery'
    },
    modelValue: $data.showGallery,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.showGallery = $event),
    onClick: _cache[21] || (_cache[21] = $event => $options.closeAll('showGallery'))
  }, {
    default: _withCtx(() => [_createVNode(_component_sidebar_item, {
      link: {
        name: 'Template',
        path: '/gallery'
      },
      onClick: _cache[18] || (_cache[18] = $event => _ctx.$emit('selected'))
    }), _createVNode(_component_sidebar_item, {
      link: {
        name: 'MC template',
        path: '/mailercloud-templates'
      },
      onClick: _cache[19] || (_cache[19] = $event => _ctx.$emit('selected'))
    })]),
    _: 1
  }, 8, ["modelValue"])) : (!this.user || !this.user.mcTemplate) && $data.permission < 5 ? (_openBlock(), _createBlock(_component_sidebar_item, {
    key: 3,
    link: {
      name: 'Template gallery',
      icon: 'gallery',
      path: '/gallery'
    },
    onClick: _cache[22] || (_cache[22] = $event => $options.closeAll())
  })) : _createCommentVNode("", true), _createVNode(_component_sidebar_item, {
    link: {
      name: 'Transactional email',
      icon: 'transational',
      path: '/transactional/dashboard'
    },
    onClick: _cache[23] || (_cache[23] = $event => $options.closeAll())
  }), _createElementVNode("li", _hoisted_2, [_createVNode(_component_b_link, {
    class: "btn btn-outline-dark mc-btn w-100 bg-light radious-10",
    to: "/change-plan"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4]),
    _: 1
  })])]);
}